const termtype = {
  UNDEFINED: 0,
  MISCELLANEOUS_EXPENSES: 1,
  TRAVEL_EXPENSES: 2,
  REIMBURSEMENT_OF_EXPENSES: 3
}
export default termtype



// WEBPACK FOOTER //
// ./src/shared/utils/termtype.js